var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forceLogin"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.loading}},[_vm._v("Please wait while we connect you to PLATFORM V3")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }